const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const WizardError = require('components/commons/wizardError/wizardError');

const CardReplaceError = props => {
    const { immCard } = props;
    const title = formatText('cardReplace-errorTitle');
    const cardAlias = immCard.get('alias').get('current');
    const goBackButtonLabel = formatText('cardReplace-goToCard', [cardAlias]).toUpperCase();
    const linkToDetails = `/myprofile/cards/${immCard.get('cardId')}/details`;
    const goBackButton = {
        label: goBackButtonLabel,
        url: linkToDetails
    }

    return (
        <div className="col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8">
            <WizardError
                errorMessage={title}
                mainButton={goBackButton}>
                <section className="card-replace-error__content row">
                    <div className="col-xs-6 col-md-5">
                        <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                    </div>
                    <div className="col-xs-6 col-md-7">
                        <FormattedText value="cardReplace-errorMessage" />
                    </div>
                </section>
            </WizardError>
        </div>
    );
};

CardReplaceError.propTypes = {
    immCard: PropTypes.object.isRequired
};

module.exports = CardReplaceError;